import React, { useState, useEffect, useRef } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ReactToPrint from "react-to-print";
import DanhSachKiemKhoApi from "service/danhSachKiemKhoApi";

export const BtnInBienBanKiemKho = ({ Id }) => {
  const scrollRef = useRef();
  const dataIn = {
    printContent: "",
  };
  const [dataInThu, UpdateDataInThu] = useState(dataIn);

  const InPhieuThu = () => {
    DanhSachKiemKhoApi.getInChiTietBienBan(Id).then((response) => {
      UpdateDataInThu({
        ...dataInThu,
        printContent: response.data,
      });
    });
  };

  useEffect(() => {
    InPhieuThu();
  }, []);
  const ComponentToPrint = React.forwardRef((props, ref) => (
    <div
      className="col-sm-12"
      style={{ width: "100%", color: "#000000" }}
      ref={ref}
    >
      <div
        style={{ padding: "15px" }}
        dangerouslySetInnerHTML={{ __html: props.data }}
      ></div>
    </div>
  ));
  return (
    <>
      <ReactToPrint
        trigger={() => {
          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
          // to the root node of the returned component as it will be overwritten.
          return (
            <a href={() => false}>
              <PopoversBootrap
                contentText="In"
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                     <img src="/app-assets/images/icon-in-danh-sach.png" />
              </PopoversBootrap>
            </a>
          );
        }}
        content={() => scrollRef.current}
        copyStyles={false}
      />

      <div style={{ display: "none" }}>
        <ComponentToPrint data={dataInThu.printContent} ref={scrollRef} />
      </div>
    </>
  );
};
